import React, {useEffect, useState} from 'react';

import {getEducationStatusData} from './DropdownDataProviders' ;

import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";

import SpinnerDiv from "./SpinnerDiv";
import PropTypes from "prop-types";

const DropdownEducationStatus = ( props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getEducationStatusData().then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, [props.halfTermsOnly]);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownEducationStatus;

DropdownEducationStatus.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownEducationStatus.propTypes = {
    onChange: PropTypes.func.isRequired
};